import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../utils/apiClient';

let analyticsModulePromise;
const getAnalyticsModule = () => {
    if (!analyticsModulePromise) analyticsModulePromise = import('react-ga4').then((m) => m.default);
    return analyticsModulePromise;
};

const usePageTracking = () => {
    const location = useLocation();
    const lastPath = useRef(null);

    useEffect(() => {
        let isCancelled = false;
        const path = location.pathname + location.search;
        if (lastPath.current === path) return;
        lastPath.current = path;

        getAnalyticsModule().then((ReactGA) => {
            if (isCancelled) return;
            ReactGA.send({ hitType: 'pageview', page: location.pathname });
        }).catch(() => {});

        // Backend page-view beacon - respects analytics consent, fire-and-forget
        try {
            const consent = localStorage.getItem('analytics_consent');
            if (consent === 'denied') return;
            const token = localStorage.getItem('token');
            const headers = { 'Content-Type': 'application/json' };
            if (token) headers['Authorization'] = `Bearer ${token}`;
            const body = JSON.stringify({ path, referrer: document.referrer || null, title: document.title || null });
            if (navigator.sendBeacon) {
                const blob = new Blob([body], { type: 'application/json' });
                navigator.sendBeacon(`${API_BASE_URL}/analytics/page-view`, blob);
            } else {
                fetch(`${API_BASE_URL}/analytics/page-view`, { method: 'POST', headers, body, keepalive: true }).catch(()=>{});
            }
        } catch {}

        return () => { isCancelled = true; };
    }, [location.pathname, location.search]);
};

export default usePageTracking;
